import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';
import * as globalFunction from 'util/GlobalFunction';

export function addEssentialService({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ showModal: true, componentType: 'Create' });
  setTimeout(() => {
    let formData = parameter;
    sectionComponent.customForm.current?.formRef.current?.setFieldsValue(formData);
    sectionComponent.customForm.current?.setState({ formData });
  }, config.setTimeoutMilliSecond);
}

export function openChangeHideShow({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    console.log(sectionComponent.child.current?.state.selectedRowKeys);
    sectionComponent.child.current?.setState({ showChangeHideShow: true });
    setTimeout(() => {
      sectionComponent.child.current?.changeHideShowFormRef.current?.setFieldValue('HideOnMailMerge', false);
    }, config.setTimeoutMilliSecond);
  } else {
    message.warning('You must select at least one essential service.');
  }
}

export function addFromTemplate({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.setState({ addFromTemplateShow: true });
  sectionComponent.child.current?.addFromTemplate.current?.getEssentialServiceTemplateDataSource();
  sectionComponent.child.current?.addFromTemplate.current?.setState({ defaultSelectedRowKeys: [], selectedRowKeys: [] });
}

export function batchDelete({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    globalFunction.confirm({
      content: 'Do you want to delete these records?',
      okText: 'Delete',
      okType: 'danger',
      callback: function () {
        httpClient
          .post('Business/EssentialService/BatchDelete', sectionComponent.child.current?.state.selectedRowKeys)
          .then(({ data }) => {
            if (data.result) {
              sectionComponent.child.current?.setState({ selectedRowKeys: [] });
              setTimeout(() => {
                sectionComponent.child.current?.getSectionDataByDefault();
              }, config.setTimeoutMilliSecond);
            } else {
              globalFunction.handleResultError(data, pageComponent);
            }
          })
          .catch(function (error) {
            globalFunction.handleError(error, pageComponent);
          });
      }
    });
  } else {
    message.warning('You must select at least one essential service.');
  }
}

export function collapseAllParts({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let data = sectionComponent.child.current?.state.data.map((part, i) => {
    part.Collapsed = true;
    return part;
  });
  sectionComponent.child.current?.setState({ data });
}
